<span
  [matTooltip]="value?.toString()"
  [ixTest]="[title, rowTestId(row), 'row-text']"
>{{ value }}</span>
